module.exports = __webpack_public_path__ + "8d7d15845ff2d88509ade50f383b3431.svg"